export const REQUEST_MASTER_PRODUCT = "REQUEST_MASTER_PRODUCT";
export const SET_MASTER_PRODUCT = "SET_MASTER_PRODUCT";
export const ERROR_GET_MASTER_PRODUCT = "ERROR_GET_MASTER_PRODUCT";

export const REQUEST_CREATE_MASTER_PRODUCT = "REQUEST_CREATE_MASTER_PRODUCT";
export const SUCCESS_CREATE_MASTER_PRODUCT = "SUCCESS_CREATE_MASTER_PRODUCT";
export const ERROR_CREATE_MASTER_PRODUCT = "ERROR_CREATE_MASTER_PRODUCT";

export const REQUEST_UPDATE_MASTER_PRODUCT = "REQUEST_UPDATE_MASTER_PRODUCT";
export const SUCCESS_UPDATE_MASTER_PRODUCT = "SUCCESS_UPDATE_MASTER_PRODUCT";
export const ERROR_UPDATE_MASTER_PRODUCT = "ERROR_UPDATE_MASTER_PRODUCT";


export const SET_MESSAGE_MASTER_PRODUCT = "SET_MESSAGE_MASTER_PRODUCT";